import { NavLink, useRouteError } from 'react-router-dom';
import PageError from '../components/PageError';
import Footer from '../components/layout/Footer';
import MainNavigation from '../components/navigation/MainNavigation';

interface RouteError {
  status?: number;
  data?: {
    message?: string;
  };
}

const Error: React.FC = () => {
  const error = useRouteError() as RouteError;

  let title = 'An error occurred!';
  let message: React.ReactNode = 'Something went wrong!';

  if (error?.status === 500 && error.data?.message) {
    message = error.data.message;
  }

  if (error?.status === 404) {
    title = 'Page Not Found';
    message = (
      <span>
        Did you get lost? Go to the{' '}
        <NavLink
          to='/'
          className='hover:underline text-primary-800 dark:text-primary-300 hover:text-primary-950 dark:hover:text-primary-100'
        >
          homepage
        </NavLink>
        , or contact us at{' '}
        <a
          href='mailto:support@yuso.be'
          className='email-link hover:underline text-primary-800 dark:text-primary-300 hover:text-primary-950 dark:hover:text-primary-100'
        >
          support@yuso.be
        </a>
        .
      </span>
    );
  }

  return (
    <div className='flex flex-col min-h-screen antialiased'>
      <MainNavigation />
      <div className='flex-grow bg-neutral dark:bg-primary-950 border-[1px] border-base-200 dark:border-primary-800 items-center flex justify-center'>
        <PageError title={title}>
          <p>{message}</p>
        </PageError>
      </div>
      <div className=' bg-gray-100 dark:bg-primary-900  border-gray-200 dark:border-primary-800 text-gray-500  dark:text-gray-200'>
        <div className='max-w-[1300px] lg:mx-auto   mx-4 md:mx-10'>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Error;
